import { mixpanel } from './mixpanel';

type TrackFunction = (
  eventName: string,
  properties?: Record<string, any>,
) => void;

/**
 * Global reference to the track function from AnalyticsContext.
 * Updated by AnalyticsProvider when it mounts.
 */
let globalTrackFunction: TrackFunction | null = null;

/**
 * Internal function to set the global track function.
 * Called by AnalyticsProvider.
 * @internal
 */
export function setGlobalTrackFunction(trackFn: TrackFunction) {
  globalTrackFunction = trackFn;
}

/**
 * Track an analytics event.
 *
 * This function will use the AnalyticsContext if available (automatically includes account_id),
 * otherwise falls back to direct Mixpanel tracking.
 *
 * @deprecated Prefer using `useAnalytics` hook in React components for better integration.
 */
export function track(eventName: string, parameters?: Record<string, any>) {
  // Try to use the context-aware track function if available
  if (globalTrackFunction) {
    globalTrackFunction(eventName, parameters);
    return;
  }

  // Fallback to direct Mixpanel tracking
  if (import.meta.env.MODE === 'development') {
    console.debug('[EVENT_TRACK]', eventName, 'parameters:', parameters);
    return;
  }

  // Push to GTM dataLayer
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...(parameters || {}),
      url: window.location.href,
      pathname: window.location.pathname,
    });
  } catch (e) {
    console.error('failed to push event to GTM dataLayer', e);
  }

  try {
    mixpanel.track(eventName, {
      ...(parameters || {}),
      url: window.location.href,
      pathname: window.location.pathname,
    });
  } catch (e) {
    console.error('failed to send event to mixpanel', e);
  }
}
